import { DialogModule, Dialog } from '@angular/cdk/dialog';
import { Component, effect, inject, OnInit, Signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { HeaderComponent } from '../../components/header/header.component';
import { StepperComponent } from '../../components/stepper/stepper.component';
import { TextAreaComponent } from '../../components/text-area/text-area.component';
import TYPES from '../../constants/types';
import { LogService } from '../../services/log.service';
import { Log } from '../../models/log';
import { filter } from 'rxjs';

@Component({
  selector: 'app-did-think',
  imports: [
    HeaderComponent,
    StepperComponent,
    ButtonComponent,
    TranslatePipe,
    MatSnackBarModule,
    DialogModule,
    TextAreaComponent
  ],
  templateUrl: './did-think.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './did-think.component.scss'
})
export class DidThinkComponent {

  BUTTON_TYPES:any;
  step: Signal<StepperComponent | undefined> = viewChild<StepperComponent>('stepper');

  whatDidThinkControl: UntypedFormControl;

  snackBar:MatSnackBar = inject(MatSnackBar);
  dialog: Dialog = inject(Dialog);
  translate: TranslateService = inject(TranslateService);

  constructor(
    private router:Router,
    private logService: LogService<Log>,
  ){
    effect( ()=> {
      this.step()?.steps()[4].nativeElement.classList.add('active');
    });

    this.whatDidThinkControl = new UntypedFormControl(this.logService.log().did_think || '');

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  next(){
    this.logService.log.update( 
      (current) => {
        return {
          ...current,
          did_think: this.whatDidThinkControl.value,
        }
      }
    );
    // this.router.navigate(['/did-do'], { replaceUrl: true });
    this.router.navigate(['/did-do']);
  }

  back(){
    // this.router.navigate(['/reason'], { replaceUrl: true });
    history.back();
  }

  close(){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'log-close-dialog.alert_title',
        message: 'log-close-dialog.alert_message'
      },
    });

    dialogRef.closed.subscribe((result:any)  => {
      if(result?.action === 'continue'){
        this.logService.canAccessMindLogRegister.set(false);
        this.router.navigate(['/home'], { replaceUrl: true });  
      }
    });   
  }

}
